import { newId } from "../config/settingConfig";

const insert = (({ fieldType, settingsGroupIdentifier, customSettingTypeId, customSettingTypeName, setInitialData, setPendingChanges, setActiveKeyAfterDelay, activeKeys }) => {
    if (fieldType === "Setting") {
        const newSetting = {
            _id: newId(),
            sequence: 999,
            name: "",
            type: "string",
            value: "",
            description: "",
            parentLocked: null,
            parentValue: null,
            hidden: false,
            locked: false
        };

        setInitialData((currentData) => {
            const newData = { ...currentData };
            const settingGroupIndex = newData.settingsGroups.findIndex(settingsGroup => settingsGroup.identifier === settingsGroupIdentifier);

            newData.settingsGroups[settingGroupIndex].settings.push(newSetting);

            return newData;
        });

        setPendingChanges((currentChanges) => {
            let settingGroupIndex = currentChanges.insert.settingsGroups.findIndex(settingGroup => settingGroup.identifier === settingsGroupIdentifier);

            if (settingGroupIndex  === -1) {
                currentChanges.insert.settingsGroups.push(
                    {
                        identifier: settingsGroupIdentifier,
                        settings: []
                    }
                );
                settingGroupIndex = currentChanges.insert.settingsGroups.length - 1;
            }            

            currentChanges.insert.settingsGroups[settingGroupIndex].settings.push(newSetting);

            return currentChanges;
        });
    }
    if (fieldType === "SettingGroup") {
        const newSettingGroup = {
            identifier: newId(),
            sequence: 999,
            name: "",
            description: "",
            editable: true,
            settings: []
        };

        setInitialData((currentData) => {
            const newData = { ...currentData };

            newData.settingsGroups.push(JSON.parse(JSON.stringify(newSettingGroup)));

            return newData;
        });

        setPendingChanges((currentChanges) => {
            const newChanges = { ...currentChanges };

            newChanges.insert.settingsGroups.push(JSON.parse(JSON.stringify(newSettingGroup)));

            return newChanges;
        });

        insert({ fieldType: "Setting", settingsGroupIdentifier: newSettingGroup.identifier, setInitialData, setPendingChanges });
        setActiveKeyAfterDelay([...activeKeys, newSettingGroup.identifier]);
    }
    if (fieldType === "CustomSettingTypeValue") {
        const newCustomSettingTypeValue = {
            _id: newId(),
            sequence: 999,
            value: "",
            editable: true
        };

        setInitialData((currentData) => {
            const newData = { ...currentData };
            const customSettingTypeIndex = newData.customSettingTypes.findIndex(customSettingType => customSettingType._id === customSettingTypeId);

            newData.customSettingTypes[customSettingTypeIndex].values.push(newCustomSettingTypeValue);

            return newData;
        });

        setPendingChanges((currentChanges) => {
            let customSettingTypeIndex = currentChanges.insert.customSettingTypes.findIndex(customSettingType => customSettingType._id === customSettingTypeId);

            if (customSettingTypeIndex === -1) {
                currentChanges.insert.customSettingTypes.push(
                    {
                        _id: customSettingTypeId,
                        name: customSettingTypeName,
                        values: []
                    }
                );
                customSettingTypeIndex = currentChanges.insert.customSettingTypes.length - 1;
            }

            currentChanges.insert.customSettingTypes[customSettingTypeIndex].values.push(newCustomSettingTypeValue);

            return currentChanges;
        });
    }
    if (fieldType === "CustomSettingType") {
        const newCustomSettingType = {
            _id: newId(),
            name: "",
            values: [],
            editable: true
        };

        setInitialData((currentData) => {
            const newData = { ...currentData };

            newData.customSettingTypes.push(JSON.parse(JSON.stringify(newCustomSettingType)));

            return newData;
        });

        setPendingChanges((currentChanges) => {
            const newChanges = { ...currentChanges };

            newChanges.insert.customSettingTypes.push(JSON.parse(JSON.stringify(newCustomSettingType)));

            return newChanges;
        });

        insert({ fieldType: "CustomSettingTypeValue", customSettingTypeId: newCustomSettingType._id, customSettingTypeName: newCustomSettingType.name, setInitialData, setPendingChanges })
        setActiveKeyAfterDelay([...activeKeys, newCustomSettingType.name]);
    }
});

const update = (({ fieldType, newValue, initialValue, changedField, _id, settingsGroupIdentifier, customSettingTypeId, parentValue, setterFunc, sequence, name, description, type, initialGroups, setPendingChanges }) => {
    if (setterFunc) {
        setterFunc(newValue);
    }

    if (parentValue !== null && initialValue === null) {
        insertWithParentValue({ settingsGroupIdentifier, parentValue, newValue, _id, sequence, name, description, type, setPendingChanges });
    }
    else if (_id.includes('TEMP_ID')) {
        updateNewField({ fieldType, newValue, settingsGroupIdentifier, initialValue, changedField, _id, customSettingTypeId, setPendingChanges })
    }
    else {
        updateExistingField({ fieldType, newValue, initialValue, changedField, _id, customSettingTypeId, setPendingChanges })
    }

    if (fieldType === "Setting" && changedField === "type") {
        const initialVal = initialGroups.find(settingGroup => settingGroup.identifier === settingsGroupIdentifier).settings.find(setting => setting._id === _id).value;
        update({ _id, initialValue: initialVal, fieldType: "Setting", newValue: "", changedField: "value", settingsGroupIdentifier, setPendingChanges });
    }

    if (fieldType === "Setting" && changedField === "hidden" && newValue === true) {
        const initialLocked = initialGroups.find(settingGroup => settingGroup.identifier === settingsGroupIdentifier).settings.find(setting => setting._id === _id).locked;

        update({ _id, initialValue: initialLocked, fieldType: "Setting", newValue: true, changedField: "locked", settingsGroupIdentifier, setPendingChanges });
    }
});

const insertWithParentValue = (({ settingsGroupIdentifier, parentValue, newValue, _id, sequence, name, description, type, setPendingChanges }) => {
    setPendingChanges((currentChanges) => {
        const newChanges = { ...currentChanges };

        let settingGroupIndex = newChanges.insert.settingsGroups.findIndex(settingGroup => settingGroup.identifier === settingsGroupIdentifier);

        if (settingGroupIndex === -1) {
            if (newValue.toString() !== parentValue.toString()) {
                newChanges.insert.settingsGroups.push(
                    {
                        identifier: settingsGroupIdentifier,
                        settings: []
                    }
                );
                settingGroupIndex = newChanges.insert.settingsGroups.length - 1;
            }
            else {
                return newChanges;
            }
        }

        let settingIndex = newChanges.insert.settingsGroups[settingGroupIndex].settings.findIndex(setting => setting._id === _id);

        if (settingIndex === -1 && newValue.toString() !== parentValue.toString()) {
            newChanges.insert.settingsGroups[settingGroupIndex].settings.push(
                {
                    _id,
                    value: newValue,
                    sequence,
                    name,
                    description,
                    type
                }
            );
        }
        else if (newValue.toString() === parentValue.toString()) {
            newChanges.insert.settingsGroups[settingGroupIndex].settings.splice(settingIndex, 1);
            if (newChanges.insert.settingsGroups[settingGroupIndex].settings.length === 0) {
                newChanges.insert.settingsGroups.splice(settingGroupIndex, 1);
            }
        }
        else {
            newChanges.insert.settingsGroups[settingGroupIndex].settings[settingIndex].value = newValue;
        }

        return newChanges;
    });
});

const updateExistingField = (({ fieldType, newValue, initialValue, changedField, _id, customSettingTypeId, setPendingChanges }) => {
    switch (fieldType) {
        case ("Setting"):
            setPendingChanges((currentChanges) => {
                const newChanges = { ...currentChanges };
                const deletedIndex = newChanges.delete.settings.findIndex(setting => setting._id === _id);
                
                if(deletedIndex !== -1) {
                    newChanges.delete.settings.splice(deletedIndex, 1);
                }

                const settingIndex = newChanges.update.settings.findIndex(setting => setting._id === _id);
                const setting = newChanges.update.settings[settingIndex];

                if (!setting) {
                    newChanges.update.settings.push(
                        {
                            _id,
                            [changedField]: newValue
                        }
                    );
                }
                else {
                    if (newValue === initialValue) {
                        delete newChanges.update.settings[settingIndex][changedField];

                        if (Object.keys(setting).length === 1) {
                            newChanges.update.settings.splice(settingIndex, 1);
                        }
                    }
                    else {
                        setting[changedField] = newValue;
                    }
                }

                return newChanges;
            });
            break;
        case ("SettingGroup"):
            setPendingChanges((currentChanges) => {
                const newChanges = { ...currentChanges };

                const settingGroupIndex = newChanges.update.settingsGroups.findIndex(settingGroup => settingGroup.identifier === _id);

                if (settingGroupIndex === -1) {
                    newChanges.update.settingsGroups.push(
                        {
                            identifier: _id,
                            [changedField]: newValue
                        }
                    )
                }
                else {
                    const settingGroup = newChanges.update.settingsGroups[settingGroupIndex];

                    if (newValue === initialValue) {
                        delete newChanges.update.settingsGroups[settingGroupIndex][changedField];

                        if (Object.keys(settingGroup).length === 1) {
                            newChanges.update.settingsGroups.splice(settingGroupIndex, 1);
                        }
                    }
                    else {
                        settingGroup[changedField] = newValue;
                    }
                }

                return newChanges;
            });
            break;
        case ("CustomSettingTypeValue"):
            setPendingChanges((currentChanges) => {
                const newChanges = { ...currentChanges };

                const customSettingTypeValueIndex = newChanges.update.customSettingTypeValues.findIndex(customSettingTypeValue => customSettingTypeValue._id === _id);
                const customSettingTypeValue = newChanges.update.customSettingTypeValues[customSettingTypeValueIndex];

                if (!customSettingTypeValue) {
                    newChanges.update.customSettingTypeValues.push(
                        {
                            _id,
                            customSettingTypeId,
                            [changedField]: newValue
                        }
                    );
                }
                else {
                    if (newValue === initialValue) {
                        delete newChanges.update.customSettingTypeValues[customSettingTypeValueIndex][changedField];

                        if (Object.keys(customSettingTypeValue).length === 2) {
                            newChanges.update.customSettingTypeValues.splice(customSettingTypeValueIndex, 1);
                        }
                    }
                    else {
                        customSettingTypeValue[changedField] = newValue;
                    }
                }

                return newChanges;
            });
            break;
        case ("CustomSettingType"):
            setPendingChanges((currentChanges) => {
                const newChanges = { ...currentChanges };

                const customSettingTypeIndex = newChanges.update.customSettingTypes.findIndex(customSettingType => customSettingType._id === _id);

                if (customSettingTypeIndex === -1) {
                    newChanges.update.customSettingTypes.push(
                        {
                            _id,
                            [changedField]: newValue
                        }
                    )
                }
                else {
                    const customSettingType = newChanges.update.customSettingTypes[customSettingTypeIndex];

                    if (newValue === initialValue) {
                        delete newChanges.update.customSettingTypes[customSettingTypeIndex][changedField];

                        if (Object.keys(customSettingType).length === 1) {
                            newChanges.update.customSettingTypes.splice(customSettingTypeIndex, 1);
                        }
                    }
                    else {
                        customSettingType[changedField] = newValue;
                    }
                }

                return newChanges;
            });
            break;
        default:
            break;
    }
});

const updateNewField = (({ fieldType, newValue, settingsGroupIdentifier, changedField, _id, customSettingTypeId, setPendingChanges }) => {
    switch (fieldType) {
        case ("Setting"):
            setPendingChanges((currentChanges) => {
                const newChanges = { ...currentChanges };

                const settingGroupIndex = newChanges.insert.settingsGroups.findIndex(settingGroup => settingGroup.identifier === settingsGroupIdentifier);
                const settingIndex = newChanges.insert.settingsGroups[settingGroupIndex].settings.findIndex(setting => setting._id === _id);
                const setting = newChanges.insert.settingsGroups[settingGroupIndex].settings[settingIndex];

                if (!setting) {
                    throw new Error('New setting cannot be located in pending inserts')
                }

                setting[changedField] = newValue;

                return newChanges;
            });
            break;
        case ("SettingGroup"):
            setPendingChanges((currentChanges) => {
                const newChanges = { ...currentChanges };

                const settingGroupIndex = newChanges.insert.settingsGroups.findIndex(settingGroup => settingGroup.identifier === _id);

                if (settingGroupIndex === -1) {
                    throw new Error('New settingGroup cannot be located in pending inserts')
                }

                newChanges.insert.settingsGroups[settingGroupIndex][changedField] = newValue;

                return newChanges;
            });
            break;
        case ("CustomSettingTypeValue"):
            setPendingChanges((currentChanges) => {
                const newChanges = { ...currentChanges };
                
                const customSettingTypeIndex = newChanges.insert.customSettingTypes.findIndex(customSettingType => customSettingType._id === customSettingTypeId);
                const customSettingTypeValueIndex = newChanges.insert.customSettingTypes[customSettingTypeIndex].values.findIndex(customSettingTypeValue => customSettingTypeValue._id === _id);
                const customSettingTypeValue = newChanges.insert.customSettingTypes[customSettingTypeIndex].values[customSettingTypeValueIndex];

                if (!customSettingTypeValue) {
                    throw new Error('New setting cannot be located in pending inserts')
                }

                customSettingTypeValue[changedField] = newValue;

                return newChanges;
            });
            break;
        case ("CustomSettingType"):
            setPendingChanges((currentChanges) => {
                const newChanges = { ...currentChanges };

                const customSettingTypeIndex = newChanges.insert.customSettingTypes.findIndex(customSettingType => customSettingType._id === _id);

                if (customSettingTypeIndex === -1) {
                    throw new Error('New customSettingType cannot be located in pending inserts')
                }

                newChanges.insert.customSettingTypes[customSettingTypeIndex][changedField] = newValue;

                return newChanges;
            });
            break;
        default:
            break;
    }
});

const deleteItem = (({ fieldType, _id, groupingId, setInitialData, setPendingChanges, setCustomTypesInUse, setCustomValuesInUse, setIsValidObj }) => {
    if (fieldType === "Setting") {
        setInitialData((currentData) => {
            const newData = { ...currentData }

            const settingGroupIndex = newData.settingsGroups.findIndex(settingsGroup => settingsGroup.identifier === groupingId);
            const settingIndex = newData.settingsGroups[settingGroupIndex].settings.findIndex(setting => setting._id === _id);

            newData.settingsGroups[settingGroupIndex].settings.splice(settingIndex, 1);

            return newData;
        });

        setPendingChanges((currentChanges) => {
            const newChanges = { ...currentChanges };

            const indexOfDelete = newChanges.delete.settings.findIndex(deletes => deletes._id === _id);

            if (indexOfDelete === -1 && !_id.includes('TEMP_ID')) {
                newChanges.delete.settings.push(
                    {
                        _id
                    }
                )
            }

            const existsInInserts =
                newChanges.insert.settingsGroups.findIndex(settingGroup => settingGroup.identifier === groupingId) !== -1 &&
                newChanges.insert.settingsGroups.find(settingGroup => settingGroup.identifier === groupingId).settings.findIndex(updates => updates._id === _id) !== -1;

            if (existsInInserts) {
                const settingGroupIndex = newChanges.insert.settingsGroups.findIndex(settingGroup => settingGroup.identifier === groupingId);
                const settingIndex = newChanges.insert.settingsGroups[settingGroupIndex].settings.findIndex(updates => updates._id === _id);

                newChanges.insert.settingsGroups[settingGroupIndex].settings.splice(settingIndex, 1);

                if(newChanges.insert.settingsGroups[settingGroupIndex].settings.length === 0 && Object.keys(newChanges.insert.settingsGroups[settingGroupIndex]).length === 2){
                    newChanges.insert.settingsGroups.splice(settingGroupIndex, 1);
                }
            }

            const settingIndex = newChanges.update.settings.findIndex(updates => updates._id === _id);

            if (settingIndex !== -1) {
                newChanges.update.settings.splice(settingIndex, 1);
            }

            return newChanges;
        });

        setCustomTypesInUse(current => {
            const newObj = { ...current };

            if (newObj[_id]) {
                delete newObj[_id];
            }

            return newObj;
        });
        setCustomValuesInUse(current => {
            const newObj = { ...current };

            if (newObj[_id]) {
                delete newObj[_id];
            }

            return newObj;
        });
    }
    if (fieldType === "SettingGroup") {
        setInitialData((currentData) => {
            const newData = { ...currentData }

            const settingGroupIndex = newData.settingsGroups.findIndex(settingsGroup => settingsGroup.identifier === _id);

            newData.settingsGroups[settingGroupIndex].settings?.forEach(setting => {
                setIsValidObj(current => {
                    const newObj = { ...current };

                    if (newObj[setting._id]) {
                        delete newObj[setting._id];
                    }

                    return newObj;
                });

                setCustomTypesInUse(current => {
                    const newObj = { ...current };

                    if (newObj[setting._id]) {
                        delete newObj[setting._id];
                    }

                    return newObj;
                });
                setCustomValuesInUse(current => {
                    const newObj = { ...current };

                    if (newObj[setting._id]) {
                        delete newObj[setting._id];
                    }

                    return newObj;
                });
            });

            newData.settingsGroups.splice(settingGroupIndex, 1);

            return newData;
        });

        setPendingChanges((currentChanges) => {
            const newChanges = { ...currentChanges };

            const indexOfDelete = newChanges.delete.settingsGroups.findIndex(deletes => deletes.identifier === _id);

            if (indexOfDelete === -1 && !_id.includes('TEMP_ID')) {
                newChanges.delete.settingsGroups.push(
                    {
                        identifier: _id
                    }
                )
            }

            const settingGroupInsertIndex = newChanges.insert.settingsGroups.findIndex(settingGroup => settingGroup.identifier === _id);

            if (settingGroupInsertIndex !== -1) {

                newChanges.insert.settingsGroups.splice(settingGroupInsertIndex, 1);
            }

            const settingGroupUpdateIndex = newChanges.update.settingsGroups.findIndex(updates => updates.identifier === _id);

            if (settingGroupUpdateIndex !== -1) {
                newChanges.update.settings.splice(settingGroupUpdateIndex, 1);
            }

            return newChanges;
        });
    }
    if (fieldType === "CustomSettingTypeValue") {
        setInitialData((currentData) => {
            const newData = { ...currentData }

            const customSettingTypeIndex = newData.customSettingTypes.findIndex(customSettingType => customSettingType.name === groupingId);
            const customSettingTypeValueIndex = newData.customSettingTypes[customSettingTypeIndex].values.findIndex(value => value._id === _id);

            newData.customSettingTypes[customSettingTypeIndex].values.splice(customSettingTypeValueIndex, 1);

            return newData;
        });

        setPendingChanges((currentChanges) => {
            const newChanges = { ...currentChanges };

            const indexOfDelete = newChanges.delete.customSettingTypeValues.findIndex(deletes => deletes._id === _id);

            if (indexOfDelete === -1 && !_id.includes('TEMP_ID')) {
                newChanges.delete.customSettingTypeValues.push(
                    {
                        _id,
                        customSettingTypeName: groupingId
                    }
                )
            }

            const existsInInserts =
                newChanges.insert.customSettingTypes.findIndex(customSettingType => customSettingType.name === groupingId) !== -1 &&
                newChanges.insert.customSettingTypes.find(customSettingType => customSettingType.name === groupingId).values.findIndex(updates => updates._id === _id) !== -1;

            if (existsInInserts) {
                const customSettingTypeIndex = newChanges.insert.customSettingTypes.findIndex(customSettingType => customSettingType.name === groupingId);
                const customSettingTypeValueIndex = newChanges.insert.customSettingTypes[customSettingTypeIndex].values.findIndex(updates => updates._id === _id);

                newChanges.insert.customSettingTypes[customSettingTypeIndex].values.splice(customSettingTypeValueIndex, 1);
            }

            const existsInUpdates = newChanges.update.customSettingTypeValues.findIndex(updates => updates._id === _id) !== -1;

            if (existsInUpdates) {
                const customSettingTypeValueIndex = newChanges.update.customSettingTypeValues.findIndex(updates => updates._id === _id);

                newChanges.update.customSettingTypeValues.splice(customSettingTypeValueIndex, 1);
            }

            return newChanges;
        });
    }
    if (fieldType === "CustomSettingType") {
        setInitialData((currentData) => {
            const newData = { ...currentData }

            const customSettingTypeIndex = newData.customSettingTypes.findIndex(customSettingType => customSettingType._id === _id);

            newData.customSettingTypes[customSettingTypeIndex].values?.forEach(value => {
                setIsValidObj(current => {
                    const newObj = { ...current };

                    if (newObj[value._id]) {
                        delete newObj[value._id];
                    }

                    return newObj;
                });
            });

            newData.customSettingTypes.splice(customSettingTypeIndex, 1);

            return newData;
        });

        setPendingChanges((currentChanges) => {
            const newChanges = { ...currentChanges };

            const indexOfDelete = newChanges.delete.customSettingTypes.findIndex(deletes => deletes._id === _id);

            if (indexOfDelete === -1 && !_id.includes('TEMP_ID')) {
                newChanges.delete.customSettingTypes.push(
                    {
                        _id
                    }
                )
            }

            const existsInInserts =
                newChanges.insert.customSettingTypes.findIndex(customSettingType => customSettingType._id === _id) !== -1;

            if (existsInInserts) {
                const customSettingTypeIndex = newChanges.insert.customSettingTypes.findIndex(customSettingType => customSettingType._id === _id);

                newChanges.insert.customSettingTypes.splice(customSettingTypeIndex, 1);
            }

            const existsInUpdates = newChanges.update.customSettingTypes.findIndex(updates => updates._id === _id) !== -1;

            if (existsInUpdates) {
                const customSettingTypeIndex = newChanges.update.customSettingTypes.findIndex(updates => updates._id === _id);

                newChanges.update.settings.splice(customSettingTypeIndex, 1);
            }

            return newChanges;
        });
    }

    setIsValidObj(current => {
        const newObj = { ...current };

        if (newObj[_id]) {
            delete newObj[_id];
        }

        return newObj;
    });
});

const handleResetValue = (({ _id, settingsGroupIdentifier, initialGroups, setPendingChanges }) => {
    setPendingChanges((currentChanges) => {
        const newChanges = { ...currentChanges };
        const initialSetting = initialGroups.find(settingGroup => settingGroup.identifier === settingsGroupIdentifier)?.settings.find(settingItem => settingItem._id === _id) || { value: null };

        if (initialSetting.value !== null) {
            const indexOfDelete = newChanges.delete.settings.findIndex(deletes => deletes._id === _id);

            if (indexOfDelete === -1) {
                newChanges.delete.settings.push(
                    {
                        _id
                    }
                );
            }
        }
        const existsInInserts =
            newChanges.insert.settingsGroups.findIndex(settingGroup => settingGroup.identifier === settingsGroupIdentifier) !== -1 &&
            newChanges.insert.settingsGroups.find(settingGroup => settingGroup.identifier === settingsGroupIdentifier).settings.findIndex(updates => updates._id === _id) !== -1;

        if (existsInInserts) {
            const settingGroupIndex = newChanges.insert.settingsGroups.findIndex(settingGroup => settingGroup.identifier === settingsGroupIdentifier);
            const settingIndex = newChanges.insert.settingsGroups[settingGroupIndex].settings.findIndex(updates => updates._id === _id);

            newChanges.insert.settingsGroups[settingGroupIndex].settings.splice(settingIndex, 1);

            if (newChanges.insert.settingsGroups[settingGroupIndex].settings.length === 0) {
                newChanges.insert.settingsGroups.splice(settingGroupIndex, 1);
            }
        }

        const settingIndex = newChanges.update.settings.findIndex(updates => updates._id === _id);

        if (settingIndex !== -1) {
            newChanges.update.settings.splice(settingIndex, 1);
        }

        return newChanges;
    });
});

const SettingsSetUtils = {
    Insert: insert,
    Update: update,
    Delete: deleteItem,
    HandleResetValue: handleResetValue
};

export default SettingsSetUtils;